export const valoresExibidosOffCanvasInformes: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separedores
  separadorLog: '',
  separadorEspecifico1: '',
  separadorEspecifico2: '',
  separadorObservacoes: '',

  //Específicos
  statusDisplay: 'Status',
  dataInforme: 'Data do informe',
  alcanceDaf: 'Alcance DAF',
  alcanceFornecedor: 'Alcance Fornecedor',
  alcanceSes: 'Alcance SES',
  imagemCard: 'Imagem Card',
  titulo: 'Título',
  resumo: 'Resumo',
  descricao: 'Descrição',
  urlMaisInfor: 'URL mais informações',
};

export const headersInformes = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: '' },
  { text: 'Status', width: 8, key: '' },
  { text: 'Data', width: 5, key: '' },
  { text: 'DAF', width: 12, key: '' },
  { text: 'SES', width: 7, key: '' },
  { text: 'Fornecedor', width: 7, key: '' },
  { text: 'Título', width: 65, key: '' },
];

export const fieldObjectInformes = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
